"use strict";

function t(t) {
  return t && "object" == typeof t && "default" in t ? t.default : t;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = t(require("react")),
  r = t(require("@memberstack/dom")),
  n = e.createContext({
    memberstack: null
  });
function o() {
  o = function o() {
    return t;
  };
  var t = {},
    e = Object.prototype,
    r = e.hasOwnProperty,
    n = "function" == typeof Symbol ? Symbol : {},
    u = n.iterator || "@@iterator",
    a = n.asyncIterator || "@@asyncIterator",
    i = n.toStringTag || "@@toStringTag";
  function c(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    c({}, "");
  } catch (t) {
    c = function c(t, e, r) {
      return t[e] = r;
    };
  }
  function s(t, e, r, n) {
    var o = Object.create((e && e.prototype instanceof p ? e : p).prototype),
      u = new I(n || []);
    return o._invoke = function (t, e, r) {
      var n = "suspendedStart";
      return function (o, u) {
        if ("executing" === n) throw new Error("Generator is already running");
        if ("completed" === n) {
          if ("throw" === o) throw u;
          return {
            value: void 0,
            done: !0
          };
        }
        for (r.method = o, r.arg = u;;) {
          var a = r.delegate;
          if (a) {
            var i = b(a, r);
            if (i) {
              if (i === f) continue;
              return i;
            }
          }
          if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
            if ("suspendedStart" === n) throw n = "completed", r.arg;
            r.dispatchException(r.arg);
          } else "return" === r.method && r.abrupt("return", r.arg);
          n = "executing";
          var c = l(t, e, r);
          if ("normal" === c.type) {
            if (n = r.done ? "completed" : "suspendedYield", c.arg === f) continue;
            return {
              value: c.arg,
              done: r.done
            };
          }
          "throw" === c.type && (n = "completed", r.method = "throw", r.arg = c.arg);
        }
      };
    }(t, r, u), o;
  }
  function l(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  t.wrap = s;
  var f = {};
  function p() {}
  function d() {}
  function h() {}
  var v = {};
  c(v, u, function () {
    return this;
  });
  var y = Object.getPrototypeOf,
    m = y && y(y(L([])));
  m && m !== e && r.call(m, u) && (v = m);
  var g = h.prototype = p.prototype = Object.create(v);
  function w(t) {
    ["next", "throw", "return"].forEach(function (e) {
      c(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function x(t, e) {
    var n;
    this._invoke = function (o, u) {
      function a() {
        return new e(function (n, a) {
          !function n(o, u, a, i) {
            var c = l(t[o], t, u);
            if ("throw" !== c.type) {
              var s = c.arg,
                f = s.value;
              return f && "object" == typeof f && r.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
                n("next", t, a, i);
              }, function (t) {
                n("throw", t, a, i);
              }) : e.resolve(f).then(function (t) {
                s.value = t, a(s);
              }, function (t) {
                return n("throw", t, a, i);
              });
            }
            i(c.arg);
          }(o, u, n, a);
        });
      }
      return n = n ? n.then(a, a) : a();
    };
  }
  function b(t, e) {
    var r = t.iterator[e.method];
    if (void 0 === r) {
      if (e.delegate = null, "throw" === e.method) {
        if (t.iterator.return && (e.method = "return", e.arg = void 0, b(t, e), "throw" === e.method)) return f;
        e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return f;
    }
    var n = l(r, t.iterator, e.arg);
    if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, f;
    var o = n.arg;
    return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, f) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function O(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function E(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function I(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(O, this), this.reset(!0);
  }
  function L(t) {
    if (t) {
      var e = t[u];
      if (e) return e.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var n = -1,
          o = function e() {
            for (; ++n < t.length;) {
              if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
            }
            return e.value = void 0, e.done = !0, e;
          };
        return o.next = o;
      }
    }
    return {
      next: M
    };
  }
  function M() {
    return {
      value: void 0,
      done: !0
    };
  }
  return d.prototype = h, c(g, "constructor", h), c(h, "constructor", d), d.displayName = c(h, i, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === d || "GeneratorFunction" === (e.displayName || e.name));
  }, t.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, c(t, i, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, t.awrap = function (t) {
    return {
      __await: t
    };
  }, w(x.prototype), c(x.prototype, a, function () {
    return this;
  }), t.AsyncIterator = x, t.async = function (e, r, n, o, u) {
    void 0 === u && (u = Promise);
    var a = new x(s(e, r, n, o), u);
    return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, w(g), c(g, i, "Generator"), c(g, u, function () {
    return this;
  }), c(g, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (t) {
    var e = [];
    for (var r in t) {
      e.push(r);
    }
    return e.reverse(), function r() {
      for (; e.length;) {
        var n = e.pop();
        if (n in t) return r.value = n, r.done = !1, r;
      }
      return r.done = !0, r;
    };
  }, t.values = L, I.prototype = {
    constructor: I,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !t) for (var e in this) {
        "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var e = this;
      function n(r, n) {
        return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var u = this.tryEntries[o],
          a = u.completion;
        if ("root" === u.tryLoc) return n("end");
        if (u.tryLoc <= this.prev) {
          var i = r.call(u, "catchLoc"),
            c = r.call(u, "finallyLoc");
          if (i && c) {
            if (this.prev < u.catchLoc) return n(u.catchLoc, !0);
            if (this.prev < u.finallyLoc) return n(u.finallyLoc);
          } else if (i) {
            if (this.prev < u.catchLoc) return n(u.catchLoc, !0);
          } else {
            if (!c) throw new Error("try statement without catch or finally");
            if (this.prev < u.finallyLoc) return n(u.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var o = this.tryEntries[n];
        if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var u = o;
          break;
        }
      }
      u && ("break" === t || "continue" === t) && u.tryLoc <= e && e <= u.finallyLoc && (u = null);
      var a = u ? u.completion : {};
      return a.type = t, a.arg = e, u ? (this.method = "next", this.next = u.finallyLoc, f) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), f;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), E(r), f;
      }
    },
    catch: function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            E(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, e, r) {
      return this.delegate = {
        iterator: L(t),
        resultName: e,
        nextLoc: r
      }, "next" === this.method && (this.arg = void 0), f;
    }
  }, t;
}
function u(t, e, r, n, o, u, a) {
  try {
    var i = t[u](a),
      c = i.value;
  } catch (t) {
    return void r(t);
  }
  i.done ? e(c) : Promise.resolve(c).then(n, o);
}
function a(t) {
  return function () {
    var e = this,
      r = arguments;
    return new Promise(function (n, o) {
      var a = t.apply(e, r);
      function i(t) {
        u(a, n, o, i, c, "next", t);
      }
      function c(t) {
        u(a, n, o, i, c, "throw", t);
      }
      i(void 0);
    });
  };
}
function i() {
  return (i = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }
    return t;
  }).apply(this, arguments);
}
var c,
  s,
  l = function l() {
    var t = e.useContext(n).memberstack;
    if (!t) throw new Error("useMemberstack can only be used within <MemberstackProvider>");
    return t;
  };
!function (t) {
  t.LOADING = "LOADING", t.UNAUTHORIZED = "UNAUTHORIZED", t.AUTHORIZED = "AUTHORIZED";
}(c || (c = {})), function (t) {
  t.LOADING = "LOADING", t.UNAUTHORIZED = "UNAUTHORIZED", t.AUTHORIZED = "AUTHORIZED";
}(s || (s = {}));
var f,
  p = function p() {
    var t,
      r = l(),
      n = e.useState(null),
      u = n[0],
      c = n[1];
    function f(t) {
      c(t ? {
        userId: t.id,
        status: s.AUTHORIZED
      } : {
        userId: null,
        status: s.UNAUTHORIZED
      });
    }
    function p() {
      return (p = a(o().mark(function t() {
        return o().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r.getCurrentMember();
              case 2:
                f(t.sent.data);
              case 5:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }
    return e.useEffect(function () {
      var t,
        e = !0;
      return e && (t = null == r ? void 0 : r.onAuthChange(f), function () {
        p.apply(this, arguments);
      }()), function () {
        var r;
        e = !1, null == (r = t) || r.unsubscribe();
      };
    }, []), i({}, u, {
      isLoggedIn: (null == u ? void 0 : u.status) === s.AUTHORIZED,
      getToken: function getToken() {
        return r.getMemberCookie();
      },
      signOut: (t = a(o().mark(function t() {
        return o().wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, r.logout();
              case 2:
                return t.abrupt("return", t.sent);
              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function () {
        return t.apply(this, arguments);
      })
    });
  },
  d = function d(t, e) {
    var r = (void 0 === e ? {} : e).includeFalseVals,
      n = void 0 !== r && r;
    return Object.entries(t).filter(function (t) {
      var e = t[1];
      return n ? null != e : e;
    }).reduce(function (t, e) {
      var r;
      return i({}, t, ((r = {})[e[0]] = e[1], r));
    }, {});
  },
  h = function h() {
    var t = l(),
      r = e.useRef(null),
      n = e.useState(!1)[1];
    return {
      openModal: function openModal(e) {
        return r.current = d(i({}, r.current, {
          type: e.type,
          planId: e.planId
        })), n(!0), t.openModal(r.current.type, d({
          planId: r.current.planId
        }));
      },
      hideModal: function hideModal() {
        return n(!1), t.hideModal();
      }
    };
  };
(f = exports.ModalType || (exports.ModalType = {})).LOGIN = "LOGIN", f.SIGNUP = "SIGNUP", f.FORGOT_PASSWORD = "FORGOT_PASSWORD", f.RESET_PASSWORD = "RESET_PASSWORD", f.PROFILE = "PROFILE";
var v = function v(t) {
    return function (r) {
      var n = h(),
        u = n.openModal,
        c = n.hideModal,
        s = null == r ? void 0 : r.onSuccess,
        l = null == r ? void 0 : r.onError,
        f = function () {
          var e = a(o().mark(function e() {
            var n;
            return o().wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.prev = 0, e.next = 3, u(i({}, r, {
                      type: t
                    }));
                  case 3:
                    n = e.sent.data, null == s || s({
                      data: n,
                      type: t
                    }), c(), e.next = 13;
                    break;
                  case 9:
                    e.prev = 9, e.t0 = e.catch(0), null == l || l(e.t0), c();
                  case 13:
                  case "end":
                    return e.stop();
                }
              }
            }, e, null, [[0, 9]]);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }();
      return e.useEffect(function () {
        f();
      }, []), null;
    };
  },
  y = v(exports.ModalType.LOGIN),
  m = v(exports.ModalType.SIGNUP),
  g = v(exports.ModalType.FORGOT_PASSWORD),
  w = v(exports.ModalType.RESET_PASSWORD),
  x = v(exports.ModalType.PROFILE),
  b = function b(t) {
    return function (r) {
      var n = p(),
        o = e.useMemo(function () {
          return t(n);
        }, [n]);
      return n.status === s.LOADING ? r.fallback || null : o ? r.children : null;
    };
  },
  O = b(function (t) {
    return t.isLoggedIn;
  }),
  E = b(function (t) {
    return !t.isLoggedIn;
  });
console.log("Memberstack React has initialized"), exports.ForgotPasswordModal = g, exports.LoggedIn = O, exports.LoggedOut = E, exports.MemberstackProtected = function (t) {
  var r = l(),
    n = e.useState(c.LOADING),
    u = n[0],
    i = n[1];
  if (!r) throw new Error("<MemberstackProtected> can only be used within <MemberstackProvider>");
  if (t.onUnauthorized && "function" != typeof t.onUnauthorized && !e.isValidElement(t.onUnauthorized)) throw new Error("onUnauthorized must be a function or a valid React element");
  function s(e) {
    if (e) {
      var r = t.allow || {},
        n = r.permissions,
        o = r.plans;
      null != n && n.length && !n.some(function (t) {
        var r;
        return null == e || null == (r = e.permissions) ? void 0 : r.includes(t);
      }) || null != o && o.length && !o.some(function (t) {
        var r;
        return null == e || null == (r = e.planConnections) ? void 0 : r.find(function (e) {
          return e.planId === t;
        });
      }) ? i(c.UNAUTHORIZED) : i(e ? c.AUTHORIZED : c.UNAUTHORIZED);
    } else i(c.UNAUTHORIZED);
  }
  function f() {
    return (f = a(o().mark(function t() {
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, r.getCurrentMember();
            case 2:
              s(t.sent.data);
            case 5:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }
  switch (e.useEffect(function () {
    var t,
      e = !0;
    return e && (t = null == r ? void 0 : r.onAuthChange(s), function () {
      f.apply(this, arguments);
    }()), function () {
      e = !1, t.unsubscribe();
    };
  }, []), u) {
    case c.LOADING:
      return t.fallback || null;
    case c.AUTHORIZED:
      return t.children;
    case c.UNAUTHORIZED:
      return e.isValidElement(t.onUnauthorized) ? t.onUnauthorized : ("function" == typeof t.onUnauthorized && t.onUnauthorized(), null);
    default:
      return null;
  }
}, exports.MemberstackProvider = function (t) {
  var o = r.init(t.config);
  return e.useEffect(function () {
    var e = setInterval(function () {
      var r, n;
      null != (r = window.__MSDOM) && r.load || document.getElementById("_ms-iframe") ? clearInterval(e) : null == (n = window.__MSDOM) || n.load({
        publicKey: t.config.publicKey
      });
    }, 200);
    return function () {
      return clearInterval(e);
    };
  }, []), e.createElement(n.Provider, {
    value: {
      memberstack: o
    }
  }, t.children);
}, exports.ProfileModal = x, exports.ResetPasswordModal = w, exports.SignInModal = y, exports.SignUpModal = m, exports.useAuth = p, exports.useCheckout = function () {
  var t = l();
  return function () {
    var e = a(o().mark(function e(r) {
      return o().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, t.purchasePlansWithCheckout(d({
                priceId: r.priceId,
                cancelUrl: r.cancelUrl,
                successUrl: r.successUrl,
                autoRedirect: r.autoRedirect
              }, {
                includeFalseVals: !0
              }));
            case 2:
              return e.abrupt("return", e.sent);
            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }();
}, exports.useCustomerPortal = function (t) {
  var e = l();
  return function () {
    var r = a(o().mark(function r() {
      return o().wrap(function (r) {
        for (;;) {
          switch (r.prev = r.next) {
            case 0:
              return r.next = 2, e.launchStripeCustomerPortal(d({
                priceIds: t.priceIds,
                returnUrl: t.returnUrl,
                autoRedirect: t.autoRedirect
              }, {
                includeFalseVals: !0
              }));
            case 2:
              return r.abrupt("return", r.sent);
            case 3:
            case "end":
              return r.stop();
          }
        }
      }, r);
    }));
    return function () {
      return r.apply(this, arguments);
    };
  }();
}, exports.useMember = function () {
  var t,
    r,
    n,
    u,
    i = l(),
    c = e.useState(null),
    s = c[0],
    f = c[1],
    p = e.useState(null),
    d = p[0],
    h = p[1];
  function v() {
    return (v = a(o().mark(function t() {
      var e;
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, i.getCurrentMember();
            case 3:
              return f(t.sent.data || null), t.next = 8, i.getMemberJSON();
            case 8:
              h((e = t.sent.data) ? null == e ? void 0 : e.json : null), t.next = 16;
              break;
            case 13:
              t.prev = 13, t.t0 = t.catch(0), console.log(t.t0);
            case 16:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 13]]);
    }))).apply(this, arguments);
  }
  return e.useEffect(function () {
    !function () {
      v.apply(this, arguments);
    }();
  }, []), {
    member: s,
    memberJSON: d,
    updateEmail: (u = a(o().mark(function t(e) {
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, i.updateMemberAuth({
                email: e
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function (t) {
      return u.apply(this, arguments);
    }),
    updatePassword: (n = a(o().mark(function t(e, r) {
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, i.updateMemberAuth({
                oldPassword: e,
                newPassword: r
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function (t, e) {
      return n.apply(this, arguments);
    }),
    updateCustomFields: (r = a(o().mark(function t(e) {
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, i.updateMember({
                customFields: e
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function (t) {
      return r.apply(this, arguments);
    }),
    updateMemberJSON: (t = a(o().mark(function t(e) {
      return o().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.next = 2, i.updateMemberJSON({
                json: e
              });
            case 2:
              return t.abrupt("return", t.sent);
            case 3:
            case "end":
              return t.stop();
          }
        }
      }, t);
    })), function (e) {
      return t.apply(this, arguments);
    })
  };
}, exports.useMemberstack = l, exports.useMemberstackModal = h;